import gsap from 'gsap'

const splash = () => {
    startSplash()
}

const startSplash = () => {
    const splash = document.querySelector('.splash')
    if (!splash) return

    const splashLogo = splash.querySelector('.logo-wrap')
    if (!splashLogo) return

    const layer = splashLogo.querySelector('svg rect[layer]')
    if (!layer) return

    gsap.set(layer, { scaleY: 0, transformOrigin: 'bottom' })

    const tl = gsap.timeline({
        paused: true,
    })

    const duration = 1

    tl.to(
        layer,
        {
            scaleY: 1,
            duration,
            ease: 'power4.out',
        },
        '>=1'
    )
    tl.to(
        splashLogo,
        {
            opacity: 0,
            scale: 0.9,
            transformOrigin: 'center',
            duration,
            ease: 'power4.out',
        },
        '+=0.2'
    )
    tl.to(
        splash,
        {
            y: '-100%',
            duration,
            ease: 'power4.in',
        },
        '<=0.1'
    )

    requestAnimationFrame(() => {
        tl.play()
    })
}

export default splash
